'use client';

import { type Masked, unmask } from '~/contentful/graphql';
import { AudioPlayer } from '~/v1/components/audioPlayer/audioPlayer';

import { type AudioPlayer_AssetFragment } from './query';

export interface FloatingAudioPlayerProps {
  data: Masked<typeof AudioPlayer_AssetFragment>;
  label: string;
}

// TODO: This should be migrated away from v1, I just don't think now is the time
export function FloatingAudioPlayer({ data }: FloatingAudioPlayerProps) {
  const { url } = unmask<typeof AudioPlayer_AssetFragment>(data);

  if (!url) {
    return null;
  }

  return <AudioPlayer src={url} isFixed isLarge />;
}
